"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var style_utils_1 = require("@nef/style-utils");
var Button_1 = require("../Button");
var Flex_1 = __importDefault(require("../Flex"));
var Link_1 = __importDefault(require("../Link"));
var Popover_1 = require("../Popover");
var StyledPopoverHeader = styled_components_1.default.h6(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  padding-bottom: 3.5px;\n  padding-top: 3.5px;\n  ", ";\n  background: ", ";\n  box-sizing: border-box;\n  color: ", ";\n  cursor: default;\n  display: flex;\n  flex-direction: row;\n  font-size: 0.9rem;\n  font-weight: 500;\n  font-family: ", ";\n  max-height: 26px;\n  overflow: auto !important;\n  overflow: overlay !important;\n\n  ", ";\n"], ["\n  ", ";\n  padding-bottom: 3.5px;\n  padding-top: 3.5px;\n  ", ";\n  background: ", ";\n  box-sizing: border-box;\n  color: ", ";\n  cursor: default;\n  display: flex;\n  flex-direction: row;\n  font-size: 0.9rem;\n  font-weight: 500;\n  font-family: ", ";\n  max-height: 26px;\n  overflow: auto !important;\n  overflow: overlay !important;\n\n  ",
    ";\n"])), style_utils_1.setPadding("x", 4), style_utils_1.setMargin("all", 0), style_utils_1.getColor("gray", 0), style_utils_1.getColor("gray", 500), style_utils_1.getFont("sansSerif"), function (props) {
    return props.$rtl && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      direction: rtl;\n      text-align: right;\n    "], ["\n      direction: rtl;\n      text-align: right;\n    "])));
});
var ActionWrapper = styled_components_1.default(Flex_1.default)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", ";\n  ", " {\n    letter-spacing: unset;\n    font-size: 0.857143rem;\n    font-weight: 400;\n    text-transform: capitalize;\n  }\n  ", " {\n    font-size: 0.857143rem;\n    font-weight: 400;\n    text-transform: capitalize;\n  }\n"], ["\n  ",
    ";\n  ", " {\n    letter-spacing: unset;\n    font-size: 0.857143rem;\n    font-weight: 400;\n    text-transform: capitalize;\n  }\n  ", " {\n    font-size: 0.857143rem;\n    font-weight: 400;\n    text-transform: capitalize;\n  }\n"])), function (props) {
    return props.$rtl
        ? styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n          ", ";\n        "], ["\n          ", ";\n        "])), style_utils_1.setPadding("left", 4)) : styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n          ", ";\n        "], ["\n          ", ";\n        "])), style_utils_1.setPadding("right", 4));
}, Button_1.StyledButton, Link_1.default);
var PopoverHeader = function (_a) {
    var children = _a.children, action = _a.action, props = __rest(_a, ["children", "action"]);
    var rtl = react_1.default.useContext(Popover_1.PopoverContext).rtl;
    return (react_1.default.createElement(Flex_1.default, { justifyContent: "between", style: { width: "100%" } },
        react_1.default.createElement(StyledPopoverHeader, __assign({}, props, { "$rtl": rtl }), children),
        action && react_1.default.createElement(ActionWrapper, { "$rtl": rtl }, action)));
};
exports.default = PopoverHeader;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=index.js.map